import update from 'immutability-helper'
import * as ACT from './actions'

export const initialState = {
  checklists: [],
  contactsChecklists: []
}

export const reducer = (state, action) => {
  const {
    checklists,
    contactsChecklists,
    checklist,
    checklistId,
    contactId,
    itemId,
    checklistItem
  } = action.payload

  const contactIndex = state.contactsChecklists.findIndex(c => c.contactId === contactId)
  const checklistIndex = contactId
    ? state.contactsChecklists[contactIndex].contactChecklists.findIndex(c => c.id === checklistId)
    : state.checklists.findIndex(c => c.id === checklistId)
  const itemIndex = contactId
    ? state.contactsChecklists[contactIndex].contactChecklists[checklistIndex].items.findIndex(
        i => i.id === itemId
      )
    : ~checklistIndex
      ? state.checklists[checklistIndex].items.findIndex(i => i.id === itemId)
      : -1

  switch (action.type) {
    case ACT.SET_CHECKLISTS:
      return { ...state, checklists, contactsChecklists }
    case ACT.ADD_CHECKLIST:
      return { ...state, checklists: [...state.checklists, checklist] }
    case ACT.EDIT_CHECKLIST:
      if (contactId) {
        return update(state, {
          contactsChecklists: {
            [contactIndex]: {
              contactChecklists: {
                [checklistIndex]: { $set: checklist }
              }
            }
          }
        })
      } else {
        return update(state, {
          checklists: {
            [checklistIndex]: { $set: checklist }
          }
        })
      }
    case ACT.EDIT_CHECKLIST_ITEM:
      if (contactId) {
        return update(state, {
          contactsChecklists: {
            [contactIndex]: {
              contactChecklists: {
                [checklistIndex]: {
                  items: {
                    [itemIndex]: { $set: checklistItem }
                  }
                }
              }
            }
          }
        })
      } else {
        return update(state, {
          checklists: {
            [checklistIndex]: {
              items: {
                [itemIndex]: { $set: checklistItem }
              }
            }
          }
        })
      }
    case ACT.DELETE_CHECKLIST_ITEM:
      if (contactId) {
        return update(state, {
          contactsChecklists: {
            [contactIndex]: {
              contactChecklists: {
                [checklistIndex]: {
                  items: {
                    $splice: [[itemIndex, 1]]
                  }
                }
              }
            }
          }
        })
      } else {
        return update(state, {
          checklists: {
            [checklistIndex]: {
              items: {
                $splice: [[itemIndex, 1]]
              }
            }
          }
        })
      }
    case ACT.ADD_CHECKLIST_ITEM:
      if (contactId) {
        return update(state, {
          contactsChecklists: {
            [contactIndex]: {
              contactChecklists: {
                [checklistIndex]: {
                  items: { $push: [checklistItem] }
                }
              }
            }
          }
        })
      } else {
        return update(state, {
          checklists: {
            [checklistIndex]: {
              items: { $push: [checklistItem] }
            }
          }
        })
      }
    case ACT.DELETE_CHECKLIST:
      if (contactId) {
        return update(state, {
          contactsChecklists: {
            [contactIndex]: {
              contactChecklists: {
                $splice: [[checklistIndex, 1]]
              }
            }
          }
        })
      } else {
        return update(state, {
          checklists: {
            $splice: [[checklistIndex, 1]]
          }
        })
      }
    default:
      throw new Error()
  }
}
